import { PackageUpgradeModal } from "./components/OfferGate";
import React, { useState } from "react";
import { Box, Header, Button, Heading, Tabs, Tab } from "grommet";
import { Magic } from "grommet-icons";
import {
  presentToastSuccess,
  presentToastErrorContent,
} from "@shared/Toast";
import { TrainingDataService } from "../../services";
import { useFetchHotel } from "./redux/fetchHotel";
import { dismissLoading, presentLoading } from "@features/shared/Loading";
import TrainingDataList from "./components/TrainingDataList";
import KnowledgeBaseUpload from "./components/KnowledgeBaseUpload";
import KnowledgeBaseList from "./components/KnowledgeBaseList";
import { useTranslation } from "react-i18next";

export default function SettingsTrainingDataStaff() {
  const { t } = useTranslation();
  const [upgrade, setUpgrade] = useState(false);
  const { hotel } = useFetchHotel();
  const [activeTab, setActiveTab] = useState(0);
  const [kbRefreshSignal, setKbRefreshSignal] = useState(0);
  const [qaRefreshSignal, setQaRefreshSignal] = useState(0);

  const handleKbUploaded = () => setKbRefreshSignal((s) => s + 1);

  const handleCreateModel = () => {
    if (!hotel?.aiEnabled) {
      setUpgrade(true);
      return;
    }
    presentLoading();
    TrainingDataService.createModel(true).then(
      () => {
        presentToastSuccess(t("settingsTraining.savingModel"));
        setQaRefreshSignal((s) => s + 1);
        dismissLoading();
      },
      (error) => {
        presentToastErrorContent(error);
        dismissLoading();
      },
    );
  };

  return (
    <Box gap="medium" justify="start" width={{ width: "90%", max: "800px" }}>
      {upgrade && <PackageUpgradeModal capability="ai" onClose={() => setUpgrade(false)} />}
      <Heading alignSelf="start" level="2">
        {t("settingsTraining.staffTitle")}
      </Heading>

      <Tabs activeIndex={activeTab} onActive={setActiveTab}>
        {/* ── Tab 1: Knowledge Base ──────────────────────────────────── */}
        <Tab title={t("settingsTraining.tabKnowledgeBase")}>
          <Box gap="large" pad={{ top: "medium" }}>
            <KnowledgeBaseUpload onUploaded={handleKbUploaded} internal />
            <KnowledgeBaseList refreshSignal={kbRefreshSignal} internal />
          </Box>
        </Tab>

        {/* ── Tab 2: Questions & Answers ───────────────────────────────── */}
        <Tab title={t("settingsTraining.tabQnA")}>
          <Box gap="medium" pad={{ top: "medium" }}>
            <Header
              align="center"
              direction="row"
              justify="center"
              gap="medium"
              fill="horizontal"
            >
              <Button
                icon={<Magic size="small" />}
                label={t("settingsTraining.saveModel")}
                primary
                color="status-warning"
                onClick={handleCreateModel}
              />
            </Header>
            <TrainingDataList internal={true} refreshSignal={qaRefreshSignal} />
          </Box>
        </Tab>
      </Tabs>
    </Box>
  );
}
